import React from 'react';

import { Checkbox, HStack, Text, VStack } from '@eluve/components';

interface OverrideSectionProps {
  label: string;
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  children: React.ReactNode;
}

export const OverrideSection: React.FC<OverrideSectionProps> = ({
  label,
  enabled,
  onEnabledChange,
  children,
}) => {
  return (
    <VStack gap={2} className="rounded-lg border border-border-primary p-3">
      <HStack gap={2} align="center">
        <Checkbox
          checked={enabled}
          onCheckedChange={(checked) => onEnabledChange(checked === true)}
        />
        <Text weight="medium">{label}</Text>
      </HStack>
      {enabled && (
        <VStack gap={2} className="pl-6">
          {children}
        </VStack>
      )}
    </VStack>
  );
};
